<template>
  <div>
    <div class="sidebar-wallet__quantity" v-if="user">
      <div class="sidebar-wallet__item">{{ user.coins + user.free_coins }} <span>{{ trans.get('left_side.middle.coins') }} </span> <i class="demo-icon icon-n-lova-coins"></i></div>
      <div class="sidebar-wallet__item">{{ user.jokers + user.free_jokers }} <span>{{ trans.get('left_side.middle.jokers') }} </span> <i class="demo-icon icon-n-joker-coins"></i></div>
    </div>

    <router-link :to="{name: 'payment',params: {unit: 'credits'}}" class="button button__fill button--tight mt-3 mx-auto">{{ trans.get('left_side.middle.charge_wallet_button') }}</router-link>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'BalanceCardComponent',
  computed: {
    ...mapState({
      userStatus: state => state.user
    }),
    ...mapGetters('user', {
      user: 'getUser',
    })
  },
};
</script>

<style scoped>

</style>
